import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Modal } from "antd";
import { StatusButton, Status } from "./Index";
import { UTILS } from "utils";

const AfsTransactionDetails = ({ orderInfo, children }) => {
  const { t } = useTranslation();
  const { currentLanguage } = useSelector((state) => state.LanguageSlice);
  const [viewAfsTransactionDetailsModal, setViewAfsTransactionDetailsModal] =
    React.useState(false);

  const info = {
    "Payment Id": {
      value: orderInfo.orderCheckoutOnlinePaymentMetadata.paymentId,
      isCopyable: true,
    },
    "Payment Method": {
      value: orderInfo?.orderCheckoutOnlinePaymentMetadata?.brand,
    },
    "Transaction ID": {
      value:
        orderInfo.orderCheckoutOnlinePaymentMetadata?.paymentCheckoutIntent
          ?.merchantTransactionId,
      isCopyable: true,
    },
    "Amount Deducted": {
      value:
        orderInfo.orderCheckoutOnlinePaymentMetadata?.paymentCheckoutIntent
          ?.amount,
    },
  };

  if(!orderInfo?.isSplitted){
    info["Payment Status"] = {
      value: <span className="text-green-500 font-bold">{t("Paid")}</span>,
    }
  }

  const copyToClipboard = async (value) => {
    const copied = await UTILS.copyTextToClipboard(value);
    if (copied) {
      UTILS.handleSuccesNotification(t("Copied to Clipboard"));
      setViewAfsTransactionDetailsModal(false);
      return;
    }
    UTILS.handleErrorNotification(t("Unable to copy to clipboard"));
  };

  return (
    <>
      <div className="text-gray-500">{t("Payment")}</div>
      <StatusButton
        text={
          orderInfo.isSplitted
            ? "Multiple Payments"
            : orderInfo.selectedPaymentMethod
            ? currentLanguage === "EN"
              ? orderInfo.selectedPaymentMethod.EN.name
              : orderInfo.selectedPaymentMethod.AR.name
            : "..."
        }
        status={orderInfo.isSplitted ? null : Status.PAID}
        onClick={() => setViewAfsTransactionDetailsModal(true)}
      />
      <Modal
        footer={null}
        open={viewAfsTransactionDetailsModal}
        onCancel={() => setViewAfsTransactionDetailsModal(false)}
        title={t("Transaction Details")}
        centered
         modalWidth="rounded-md border border-gray-300 top-0 w-full md:w-2/3"
      >
        <table className="border-collapse border border-gray-300 w-full my-8">
          <tbody>
          {Object.keys(info).map((key) => (
            <tr key={key} className="border border-slate-300">
              <td className="border border-slate-300 p-2 font-bold">
                {t(key)}
              </td>
              <td className="p-2 flex items-center gap-2 justify-between w-full flex-wrap">
                <span className="break-all" >{info[key]?.value}</span>
                {info[key]?.isCopyable ? (
                  <button
                    className="bg-blue-400 text-white px-2 py-1 rounded-md hidden-print"
                    onClick={() => copyToClipboard(info[key]?.value)}
                  >
                    {t("Copy")}
                  </button>
                ) : null}
              </td>
            </tr>
          ))}
          </tbody>
          </table>
      </Modal>
    </>
  );
};

export default AfsTransactionDetails;
